<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData">
        <element-processor-step :data="processorData.steps[0]" :type="'simple'">
          <ul class="form-item-list">
            <li><h3>{{title}} 상담 예약</h3></li>
            <li>
              <div class="form-item-caution">
                {{processorData.steps[0].formData.name.value}} 고객님 상담시간 및 남기실 말씀 입력 후 하단의 예약버튼을 눌러주세요.
              </div>
            </li>

            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[0].formData.consultDate.value" :error="processorData.steps[0].formData.consultDate.error" :label="processorData.steps[0].formData.consultDate.label" :placeholder="processorData.steps[0].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[0].formData.consultTime.value" :date="processorData.steps[0].formData.consultDate.value" :error="processorData.steps[0].formData.consultTime.error" :label="processorData.steps[0].formData.consultTime.label" :placeholder="processorData.steps[0].formData.consultTime.placeholder" />
            </li>
            <li><element-textarea v-model="processorData.steps[0].formData.consultRemark.value" :error="processorData.steps[0].formData.consultRemark.error" :label="processorData.steps[0].formData.consultRemark.label" :placeholder="processorData.steps[0].formData.consultRemark.placeholder" /></li>
          </ul>
          <div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[1]" :type="'simple'">
          <include-consult-complete :data="processorData.steps[1]" />
        </element-processor-step>

      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment'

export default {
  data(){
    return {
      title: "",
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "상담 예약",
        steps: [
          {
            title: "상담 예약",
            formData: {
              insureName: {
                label: "보험종목",
                value: "",
                error: "",
                item: [],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                error: "",
                placeholder: "이름 입력",
                validations: [
                  // { type: "required", message: "필수항목입니다" }
                ]
              },
              phone: {
                label: "휴대폰번호",
                value: "",
                error: "",
                placeholder: "- 없이 입력 (예:01012345678)",
                validations: [
                  // { type: "required", message: "필수항목입니다" }
                ]
              },
              consultDate: {
                label: "상담일시",
                value: new Date(),
                placehodler: "날짜",
                error: "",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              }
            }
          },
          {
            title: "상담 예약이 완료되었습니다.",
            label: "예약하신 상담일시에 상담원이 친절하게 안내해 드리겠습니다."
          }
        ] // steps
      }
    }
  },
  mounted(){
  },
  created() {
    // customer=[_회원]&adminj=[_접수자]&admin=[_상담자]&ectype=[_보험종목]&source=[_경로]&memo=[_접수자메모]
    var tmp = {
      customer: this.$route.query.customer ? this.$route.query.customer : "",
      adminj: this.$route.query.adminj ? this.$route.query.adminj : "",
      admin: this.$route.query.admin ? this.$route.query.admin : "",
      ectype: this.$route.query.ectype ? this.$route.query.ectype : "",
      source: this.$route.query.source ? this.$route.query.source : "",
      memo: this.$route.query.memo ? this.$route.query.memo : "",
    }

    if(this.$route.query.ectype) {
      this.processorData.title = `${this.$route.query.ectype} 상담 예약`
      this.processorData.steps[0].title = `${this.$route.query.ectype} 상담 예약`
      this.processorData.steps[0].formData.insureName.value = this.$route.query.ectype
      this.title = this.$route.query.ectype
    }else{

    }

    if(this.$route.query.customer) {

      this.$store.dispatch( "customer/getItem", this.$route.query.customer)
      .then(res => {
        this.processorData.steps[0].formData.name.value = res.data.data.customer_name
        this.processorData.steps[0].formData.phone.value = res.data.data.customer_phone_number
      });
    }

    if(this.$route.query.memo) {
      this.processorData.steps[0].formData.consultRemark.value = this.$route.query.memo
    }

    if(this.$store.state.customer.profile){
      this.processorData.steps[0].formData.name.value = this.$store.state.customer.profile.customer_name
      this.processorData.steps[0].formData.phone.value = this.$store.state.customer.profile.customer_phone_number
    }else{

    }


    tmp = Object.assign(this.$route.query, tmp)
    this.$router.replace({query: null}).catch(err =>{})
    this.$router.replace({query: tmp}).catch(err =>{})

  },

  methods: {
    submit( finalData ) {
      // finalData.cid = this.$route.query.cid ? this.$route.query.cid: '';

      if(this.$route.query.customer) {
        finalData.customer_id = this.$route.query.customer
      }
      if(this.$route.query.adminj) {
        finalData.adminj = this.$route.query.adminj
      }
      if(this.$route.query.admin) {
        finalData.admin = this.$route.query.admin
      }
      if(this.$route.query.source) {
        finalData.source = this.$route.query.source
      }
      this.$store.dispatch( "reservation/createItems", finalData );
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].subLabel = value;

      if(this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value) >= 0){

        var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value);
        if(value === '미가입' && !this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].requirement){
          this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.splice(index, 1);
        }
      }else{
        if(value != '미가입'){
          var tmp = { label: this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value, value: value };
          this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.push( tmp )
        }
      }
    }
  }
}
</script>
